
import Backbone from '@polleverywhere/backbone'
import { contextualize, cutlassEvent } from '@polleverywhere/cutlass'
import { acceptCookies, cookiesAllowed } from '../../util/cookie_consent'
import { html, render } from 'lit-html'
import openWindow from '../../util/open_window'

import '@polleverywhere/pe-button'
import './style.scss'

const ALLOW_COOKIES_EVENT = 'allow_cookies'

const linkOrButtonSelector = 'a, button'

// Not using NotificationManager as this can't be superceded by other notifications
// and we need to link to the privacy policy
function buildBanner () {
  return html`
    <div name=icon><pe-graphic name=info type=icon></pe-graphic></div>
    <div name=content>
      <div name='title'>Accept our Cookie Policy</div>
      <p>
        This website and its third-party tools use cookies and data storage in the United States.
        Learn more about why this is required in our
        <pe-button type=link label='Privacy Policy'
          @click=${e => {
            e.stopPropagation()
            openWindow('https://www.polleverywhere.com/privacy-policy', this.app.state)
          }}
        ></pe-button>.
      </p>
      <p>
        By continuing to browse, you accept the use of cookies and the data protection policy.
      </p>
      <div name=controls>
        <pe-button @click=${e => {
          e.stopPropagation()
          this.dismiss()
        }} name=dismiss label=Dismiss type=ghost></pe-button>
        <pe-button @click=${e => {
          e.stopPropagation()
          this.accept()
        }} name=action label=Agree></pe-button>
      </div>
    </div>
  `
}

function removeBanner () {
  this.showingNotification = false
  this.remove()
}

export default class CookieConsentManager extends Backbone.View {
  static requiredFor (role, mode = 'standalone') {
    return mode !== 'integration' && role === 'participant'
  }

  get cookiesAllowed () {
    return cookiesAllowed(this.app.state)
  }

  get className () { return 'cookie-consent-manager' }
  get tagName () { return 'aside' }
  get attributes () { return { hidden: true } }

  accept () {
    cutlassEvent(this.el, 'accept')
    this.handleAccept()
  }

  dismiss () {
    cutlassEvent(this.el, 'dismiss')
    removeBanner.call(this)
  }

  implicitAccept () {
    cutlassEvent(this.el, 'implicit_accept')
    this.handleAccept()
  }

  initialize ({ app, forceShow }) {
    this.app = app
    this.showingNotification = false
    this.forceShow = !!forceShow
    this.onLinkOrButtonClick = () => this.implicitAccept()

    contextualize(this.el, 'cookie_banner')
  }

  showBannerUntilCookiesAccepted () {
    if (this.showingNotification) { return }

    if (this.cookiesAllowed && !this.forceShow) {
      this.trigger(ALLOW_COOKIES_EVENT, {})
      return
    }

    render(buildBanner.call(this), this.el, {
      eventContext: this
    })

    this.showingNotification = true
    this.el.removeAttribute('hidden')

    $(document).one('click', linkOrButtonSelector, this.onLinkOrButtonClick)

    cutlassEvent(this.el, 'view')
  }

  handleAccept () {
    $(document).off('click', linkOrButtonSelector, this.onLinkOrButtonClick)

    removeBanner.call(this)

    if (this.cookiesAllowed) { return }

    acceptCookies()
    this.trigger(ALLOW_COOKIES_EVENT)
  }
}
